/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "CloneGridRequest": {
                        "fields": {
                          "idempotencyKey": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "sourceLocation": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "pageIds": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "targetLocations": {
                            "type": "string",
                            "id": 4,
                            "rule": "repeated"
                          }
                        }
                      },
                      "CloneGridResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CloneGridRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.CloneGridResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CloneGridRequest @ squareup/connect/v2/catalog/interfaces/clone-grid.proto at 20:1
 */
export const CloneGridRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CloneGridRequest');
fixType(CloneGridRequest, {
  idempotencyKey: {
    required: true,
    notEmpty: true
  },
  sourceLocation: {
    required: true
  },
  pageIds: {
    required: true
  },
  targetLocations: {
    required: true
  }
});
Builder.createAndAttachToType(CloneGridRequest);
/**
 * SOURCE CloneGridResponse @ squareup/connect/v2/catalog/interfaces/clone-grid.proto at 64:1
 */
export const CloneGridResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.CloneGridResponse');
fixType(CloneGridResponse);
Builder.createAndAttachToType(CloneGridResponse);